<div class="table-row skeleton-row">
  <div class="table-cell main-label-cell sticky-main-cell-left">
    <div class="name">
      <div>
        <div
          class="person-name placeholder-pill"
          style="width: 150px; height: 16px; margin-bottom: 4px"></div>
        <div
          class="source-customer placeholder-pill"
          style="width: 120px; height: 12px"></div>
      </div>
    </div>
  </div>
</div>
